import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';



@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  pictures:any;
  constructor(private route: ActivatedRoute) { }
z:any;
keys:any[];
facu: any;
emp:any;
writtencontact:any;
newsi:any;
readmore:any= {};
  ngOnInit() {
    this.z = this.route.snapshot.data['omolayoresolver'];
    console.log(this.z);

    this.keys = Object.keys(this.z.pictures);
    this.emp = Object.keys(this.z.employees);
    this.facu = Object.keys(this.z.faculties);
    this.writtencontact = Object.keys(this.z.writtencontact);
    this.newsi = Object.keys(this.z.news);
    this.newsi.reverse();
    this.newsi.forEach((nnnm)=>{
      this.readmore[nnnm]=false;
      console.log(this.readmore);
    })
console.log(this.facu);

console.log(this.z.faculties);
console.log(this.z.faculties[this.facu[0]]);

console.log(this.z[this.keys[0]]);

  }
faculty(facc, picture, number){


   document.getElementById(facc).innerHTML = this.z.faculties[facc].description;
   document.getElementById("services"+number).style.backgroundImage = "url("+picture+")";

}
  services(i): string{
    if (i%2 == 1){
      return "services1"
    }else{
      return "services"
    }
  }
  display(i):string{

    if (i == 0){ return "display"; console.log('display');}else{
      return "nodisplay"; console.log('nodisplay');

    }
  }
emmployees(i){
  document.getElementById('emolews'+i).innerHTML = this.z.employees[i].description;
}

neews(i){
  if(this.readmore[i] == false){
  let substringi;
  if(this.z.news[i].description.length>154){
substringi = this.z.news[i].description.substr(0, 150)+"..."}else{
  substringi =  this.z.news[i].description;
  }
  document.getElementById('nws'+i).innerHTML = substringi;
}else{
  document.getElementById('nws'+i).innerHTML = this.z.news[i].description;
}
}

readimore(i){

this.readmore[i] = true;
  }

}
